import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { OccEndpointsService, TranslationService } from '@spartacus/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SmartTireService {
  public defaultvistInfo = {
    firstName: '',
    lastName: '',
    eMail: '',
    valueDisclaimer: false,
  };

  defaultFleetInfo = {
    numOfVechicles: 100,
    avgVechicles: 75000,
    tierPerVechicles: 8,
    tireInspection: 2,
    avgUnderInflation: 15,
    tireLife: 12500,
    downtimeInstance: 1,
    downtimeInstanceForVechicles: 2,
    fuelConsumption: 7.35,
  };

  defaultmaintenance = {
    costOfDiesel: 2.7,
    costPerTire: 350.0,
    serviceCostUSD: 4.0,
    serviceCostMins: 2,
    serviceCostHours: 15.0,
    costPerDowntime: 500.0,
  };

  defaultroiReduce = {
    roiReduce: 40,
  };

  defaultData = [
    {
      normal: 206769.23,
      smartwave: 168000.0,
      savings: 38769.23,
      displayValue: '206,769.23_168,000.00_38,769.23',
    },
    {
      normal: 2797057.91,
      smartwave: 2755102.04,
      savings: 41955.87,
      displayValue: '2,797,057.91_2,755,102.04_41,955.87',
    },
    {
      normal: 9600.0,
      smartwave: 5760.0,
      savings: 3840.0,
      displayValue: '9,600.00_5,760.00_3,840.00',
    },
    {
      normal: 25000.0,
      smartwave: 13000.0,
      savings: 12000.0,
      displayValue: '25,000.00_13,000.00_12,000.00',
    },
    {
      normal: 3038427.14,
      smartwave: 2941862.04,
      savings: 96565.1,
      displayValue: '3,038,427.14_2,941,862.04_96,565.10',
    },
    {
      roi: 965.65,
      displayValue: '965.65',
    },
  ];

  private popUpData = { fName: '', lName: '', emailId: '' };

  toolTipData$ = new BehaviorSubject<any[]>([]);
  currentComponent$ = new BehaviorSubject<any>(null);
  valueDisclaimer$ = new BehaviorSubject<any>(false);

  vistInfoData$ = new BehaviorSubject<any>(this.defaultvistInfo);
  fleetInfoData$ = new BehaviorSubject<any>(this.defaultFleetInfo);
  maintenance$ = new BehaviorSubject<any>(this.defaultmaintenance);
  roiReduce$ = new BehaviorSubject<any>(this.defaultroiReduce);
  savingsData = new BehaviorSubject<any[]>(this.defaultData);
  savingsData$ = this.savingsData.asObservable();
  popUpData$ = new BehaviorSubject<any>(this.popUpData);

  resetForms$ = new BehaviorSubject<any>(null);
  fleetSizeTractors: any;
  tractorTradeInCycle: any;
  fleetSizeTrailers: any;
  trailerTradeInCycle: any;
  B4: any;
  B5: any;
  B6: any;
  B7: any;
  B8: any;
  B9: any;
  B10: any;
  B11: any;
  F9: any;
  B15: any;
  B16: any;
  B17: any;
  D18: any;
  H18: any;
  B18: any;
  M19: any;
  res1_norm: any;
  res1_smar: any;
  res1_save: any;
  res2_norm: any;
  res2_smar: any;
  res2_save: any;
  res3_norm: any;
  res3_smar: any;
  res3_save: any;
  res4_norm: any;
  res4_smar: any;
  res4_save: any;
  tot_norm: any;
  tot_smar: any;
  tot_save: any;
  tot_anual: any;
  payload: any;
  TableCalculation() {
    this.fleetInfoData$?.subscribe((data) => {
      this.B4 = data.numOfVechicles;
      this.B5 = data.avgVechicles;
      this.B6 = data.tierPerVechicles;
      this.B7 = data.tireInspection;

      this.B8 = data.avgUnderInflation;
      this.B9 = data.downtimeInstance;
      this.B10 = data.tireLife;

      this.B11 = data.fuelConsumption;
      this.F9 = data.downtimeInstanceForVechicles;
    });
    this.maintenance$?.subscribe((data) => {
      this.B15 = data.costOfDiesel;
      this.B16 = data.costPerTire;
      this.B17 = data.costPerDowntime;
      this.D18 = data.serviceCostMins;
      this.H18 = data.serviceCostHours;
      this.B18 = this.D18 * this.B6 * (this.H18 / 60);
    });

    this.roiReduce$?.subscribe((data) => {
      this.M19 = data.roiReduce;
    });

    this.res1_norm =
      ((((this.B5 * 10) / ((this.B10 * (100 - this.B8 * 1.25)) / 100)) * this.B6 * this.B16) / 10) * this.B4;
    this.res1_smar = ((((this.B5 * 10) / this.B10) * this.B6 * this.B16) / 10) * this.B4;
    this.res1_save = this.res1_norm - this.res1_smar;
    //alert("Row1-"+' '+this.res1_norm+' '+this.res1_smar+' '+this.res1_save);
    const row1 = {
      res1_norm: this.CurrencyFormatted(this.res1_norm),
      res1_smar: this.CurrencyFormatted(this.res1_smar),
      res1_save: this.CurrencyFormatted(this.res1_save),
      displayValue: '',
    };
    row1.displayValue = `${row1.res1_norm}_${row1.res1_smar}_${row1.res1_save}`;
    this.updateRow(0, row1);

    this.res2_norm = (this.B15 / (((100 - this.B8 * 0.1) / 100) * this.B11)) * this.B5 * this.B4;
    this.res2_smar = (this.B15 / this.B11) * this.B5 * this.B4;
    this.res2_save = this.res2_norm - this.res2_smar;
    const row2 = {
      res2_norm: this.CurrencyFormatted(this.res2_norm),
      res2_smar: this.CurrencyFormatted(this.res2_smar),
      res2_save: this.CurrencyFormatted(this.res2_save),
      displayValue: '',
    };
    row2.displayValue = `${row2.res2_norm}_${row2.res2_smar}_${row2.res2_save}`;
    this.updateRow(1, row2);

    this.res3_norm = this.B18 * this.B7 * 12 * this.B4;
    this.res3_smar = ((100 - this.M19) / 100) * this.res3_norm;
    this.res3_save = this.res3_norm - this.res3_smar;
    //alert("row3-"+' '+this.res3_norm+' '+this.res3_smar+' '+this.res3_save);

    const row3 = {
      res3_norm: this.CurrencyFormatted(this.res3_norm),
      res3_smar: this.CurrencyFormatted(this.res3_smar),
      res3_save: this.CurrencyFormatted(this.res3_save),
      displayValue: '',
    };
    row3.displayValue = `${row3.res3_norm}_${row3.res3_smar}_${row3.res3_save}`;
    this.updateRow(2, row3);

    this.res4_norm = (this.B9 / this.F9) * this.B4 * this.B17;
    this.res4_smar = this.res4_norm * 0.52;
    this.res4_save = this.res4_norm - this.res4_smar;
    const row4 = {
      res4_norm: this.CurrencyFormatted(this.res4_norm),
      res4_smar: this.CurrencyFormatted(this.res4_smar),
      res4_save: this.CurrencyFormatted(this.res4_save),
      displayValue: '',
    };
    row4.displayValue = `${row4.res4_norm}_${row4.res4_smar}_${row4.res4_save}`;
    this.updateRow(3, row4);

    this.tot_norm = this.res1_norm + this.res2_norm + this.res3_norm + this.res4_norm;
    this.tot_smar = this.res1_smar + this.res2_smar + this.res3_smar + this.res4_smar;
    this.tot_save = this.res1_save + this.res2_save + this.res3_save + this.res4_save;

    const row5 = {
      tot_norm: this.CurrencyFormatted(this.tot_norm),
      tot_smar: this.CurrencyFormatted(this.tot_smar),
      tot_save: this.CurrencyFormatted(this.tot_save),
      displayValue: '',
    };
    row5.displayValue = `${row5.tot_norm}_${row5.tot_smar}_${row5.tot_save}`;
    this.updateRow(4, row5);

    this.tot_anual = this.tot_save / this.B4;
    const row6 = {
      tot_anual: this.CurrencyFormatted(this.tot_anual),
      displayValue: '',
    };
    row6.displayValue = `${row6.tot_anual}`;
    this.updateRow(5, row6);
  }

  CurrencyFormatted(amount: number) {
    if (amount != null || undefined) {
      // Round to 2 decimal places
      const roundedAmount = amount.toFixed(2);

      // Add commas for thousands separator
      const parts = roundedAmount.toString().split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');

      // Join the parts and return
      return parts.join('.');
    } else {
     return '';
    }
  }

  getCurrentData() {
    return this.savingsData.value;
  }

  triggerReset() {
    this.vistInfoData$.next(this.defaultvistInfo);
    this.fleetInfoData$.next(this.defaultFleetInfo);
    this.maintenance$.next(this.defaultmaintenance);
    this.savingsData.next(this.defaultData);
  }

  postAPI() {
    return  this.http.post(this.occService.buildUrl('smartireROI/sentemail'),this.createPayload(),{ responseType: 'text' });
  }
  createPayload() {
    this.payload = {
      eMail: '',
      firstName: '',
      lastName: '',
      valueDisclaimer: '',

      numOfVechicles: '',
      avgVechicles: '',
      tierPerVechicles: '',
      tireInspection: '',
      avgUnderInflation: '',
      tireLife: '',
      downtimeInstance: '',
      downtimeInstanceForVechicles: '',
      fuelConsumption: '',

      costOfDiesel: '',
      costPerTire: '',
      serviceCostUSD: '',
      serviceCostMins: '',
      serviceCostHours: '',
      costPerDowntime: '',

      displayValue1: '',
      displayValue2: '',
      displayValue3: '',
      displayValue4: '',
      displayValue5: '',
      displayValue6: '',
      displayValue7: '',
      total: '',
      roiReduce: '',

      roiPercent:'',

      FName: '',
      LName: '',
      emailId: '',
    };
    this.vistInfoData$.subscribe((x:any) => {
      this.payload.eMail = x?.eMail ;
      this.payload.firstName = x?.firstName ;
      this.payload.lastName = x?.lastName ;
      this.payload.valueDisclaimer = x?.valueDisclaimer ;
    });

    this.fleetInfoData$.subscribe((x:any) => {
      this.payload.numOfVechicles = x?.numOfVechicles ;
      this.payload.avgVechicles=x?.avgVechicles,
      this.payload.tierPerVechicles = x?.tierPerVechicles ;
      this.payload.tireInspection=x?.tireInspection,
      this.payload.avgUnderInflation = x?.avgUnderInflation ;
      this.payload.tireLife = x?.tireLife ;
      this.payload.downtimeInstance = x?.downtimeInstance ;
      this.payload.downtimeInstanceForVechicles = x?.downtimeInstanceForVechicles ;
      this.payload.fuelConsumption = x?.fuelConsumption ;
    });


    this.maintenance$.subscribe((x:any) => {
      this.payload.costOfDiesel = x?.costOfDiesel ;
      this.payload.costPerTire = x?.costPerTire ;
      this.payload.serviceCostUSD = x?.serviceCostUSD ;
      this.payload.serviceCostMins = x?.serviceCostMins ;
      this.payload.serviceCostHours = x?.serviceCostHours ;
      this.payload.costPerDowntime = x?.costPerDowntime ;
    });


    this.savingsData$.subscribe((x:any) => {
      this.payload.displayValue1 = x[0]?.displayValue ;
      this.payload.displayValue2 = x[1]?.displayValue ;
      this.payload.displayValue3 = x[2]?.displayValue ;
      this.payload.displayValue4 = x[3]?.displayValue ;
      this.payload.total = x[4]?.displayValue;
      this.payload.roiReduce = x[5]?.displayValue;
    });
    this.popUpData$.subscribe((x:any) => {
      this.payload.FName = x?.fName ;
      this.payload.LName = x?.lName ;
      this.payload.emailId = x?.emailId ;
    });
    this.roiReduce$.subscribe((x:any) => {
      this.payload.roiPercent = x?.roiReduce ;

    });


const payload=
{
firstName:this.payload?.firstName,
lastName:this.payload?.lastName,
companyEmail:  this.payload?.eMail,
disclaimer: this.payload?.valueDisclaimer,

numOfVechicles :this.payload?.numOfVechicles ,
avgVechicles:this.payload?.avgVechicles,
tierPerVechicles : this.payload?.tierPerVechicles ,
tireInspection:this.payload?.tireInspection,
avgUnderInflation : this.payload?.avgUnderInflation ,
tireLife : this.payload?.tireLife ,
downtimeInstance : this.payload?.downtimeInstance ,
downtimeInstanceForVechicles :this.payload?.downtimeInstanceForVechicles ,
fuelConsumption : this.payload?.fuelConsumption ,

costOfDiesel :this.payload?.costOfDiesel ,
costPerTire :this.payload?.costPerTire ,
serviceCostUSD :this.payload?.serviceCostUSD ,
serviceCostMins:this.payload?.serviceCostMins ,
serviceCostHours :this.payload?.serviceCostHours ,
costPerDowntime :this.payload?.costPerDowntime ,

displayValue1 :this.payload?.displayValue1 ,
displayValue2 :this.payload?.displayValue2 ,
displayValue3 :this.payload?.displayValue3 ,
displayValue4 :this.payload?.displayValue4 ,
total :this.payload?.total,
roiReduce : this.payload?.roiReduce,

roiPercent:this.payload?.roiPercent,

FName: this.payload?.FName,
LName: this.payload?.LName,
emailId: this.payload?.emailId,
bypassRecaptchaEmailDomain: false
}

return payload;
  }
  updateRow(index, rowData): void {
    const currentData = this.savingsData.value;
    if (index >= 0 && index < currentData.length) {
      currentData[index] = rowData;
      this.savingsData.next([...currentData]);
    }
  }

  constructor(
    private matdialog: MatDialog,
    private http: HttpClient,
    private occService: OccEndpointsService,
    private translationService: TranslationService
  ) {}
}
